import { generateHTML } from "@tiptap/react";
import { fetchBffBlob, jsonPost, saveBlob } from "../../download/downloadBffFile";
import { extensions, parseTiptapContent } from "./TipTap";

export const renderTextDocumentAsPdf = ({ fileName, content }: { fileName: string; content: string }): Promise<Blob> =>
  fetchBffBlob("/api/download/text-documents", jsonPost({ content: generateHTMLFromTextDocument(content), fileName }));

export const downloadTextDocument = async ({ fileName, content }: { fileName: string; content: string }) => {
  if (!content) throw Error("No content");
  saveBlob(await renderTextDocumentAsPdf({ fileName, content }), `${fileName}.pdf`);
};

export const generateHTMLFromTextDocument = (content: string) =>
  content ? generateHTML(parseTiptapContent(content), extensions) : "";
